import { drawersActions, useDispatchDrawers, useOpenDrawer } from "contexts/drawers";

import { DrawerComponent } from "./Drawer";

/**
 * Drawer Container
 *
 * Container that renders the currently open drawer.
 * Only one drawer can be open at a time.
 */
export function DrawerContainer() {
    const openDrawer = useOpenDrawer();
    const dispatch = useDispatchDrawers();

    const handleClose = () => {
        dispatch(drawersActions.closeDrawer());
    };

    if (!openDrawer) {
        return null;
    }

    const DrawerContent = openDrawer.component;

    return (
        <DrawerComponent
            title={openDrawer.title}
            icon={openDrawer.icon}
            isOpen={true}
            onClose={handleClose}
            hideHeader={openDrawer.hideHeader}
            data-testid={`drawer-${openDrawer.id}`}
        >
            <DrawerContent onClose={handleClose} />
        </DrawerComponent>
    );
}
